export default function <T extends Record<string, string | number>>(data: T[]) {
  if (!data.length) {
    console.warn('No data to export.')
    throw new Error('No data to export.')
  }

  const headers = Object.keys(data[0])
  const csvRows = [
    headers.join(','), // Header row
    ...data.map((row) =>
      headers
        .map((field) => {
          let value = row[field]

          // Escape double quotes and wrap in quotes if needed
          if (typeof value === 'string') {
            value = value.replace(/"/g, '""') // Escape quotes
            if (value.includes(',') || value.includes('\n')) {
              value = `"${value}"`
            }
          }

          return value
        })
        .join(','),
    ),
  ]

  const csvString = csvRows.join('\n')
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' })
  return blob
}
